import { HierarchicalTreeTitleVariables } from '../../../teams/components/HierarchicalTree/hierarchicalTreeTitleVariables';

export const hierarchicalTreeTitleVariables = (siteVars: any): HierarchicalTreeTitleVariables => {
  return {
    defaultColor: siteVars.colors.white,
  };
};
